// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1i9rF","bigColWidth":"Table_bigColWidth__23yCJ","biggerColWidth":"Table_biggerColWidth__1sDNx","row":"Table_row__2jaMF","col":"Table_col__YrwDg"};